export const SNOWPLOW = {
    SCHEMA: 'iglu:com.raisin/event_schema/jsonschema/1-0-3',
    TEST_ENDPOINT: 'https://com-raisin-prod1.mini.snplow.net',
    PROD_ENDPOINT: 'collector.raisin.com',
    TRACKER_ID: 'production',
    APP_IDS: {
        'www.weltsparen.de': 'prod',
        'www.weltsparen.at': 'prod_at',
        'www.raisin.com': 'prod_com',
        'www.raisin.com/pl-pl': 'prod_pl',
        'www.raisin.com/en-us': 'prod_us',
        'www.raisin.co.uk': 'prod_uk',
        'www.raisin.com/en-gb': 'prod_uk',
        'www.raisin.ie': 'prod_ie',
        'www.raisin.com/en-ie': 'prod_ie',
        'www.raisin.es': 'prod_es',
        'www.raisin.com/es-es': 'prod_es',
        'www.raisin.fr': 'prod_fr',
        'www.raisin.com/fr-fr': 'prod_fr',
        'www.raisin.com/de-at': 'prod_at',
        'www.raisin.com/de-de': 'prod',
        'www.raisin.nl': 'prod_nl',
        'www.raisin.com/nl-nl': 'prod_nl',
        'www.raisin.com/fi-fi': 'prod_fi',
        'www.raisin.bank': 'prod_bank',
        'cap.weltsparen.de': 'cap_deu',
        'cap.raisin.co.uk': 'cap_gbr',
        default: 'prod_com',
    },
};
export const EXPONEA = {
    PROD_TOKEN: {
        EU: '5ad5bb04-cff9-11ea-8069-62850c207816',
        GB: '3d293c22-f36a-11ea-922b-eafa027747e1',
        US: '6fae9458-723e-11ed-8e87-1eb986dbebc2',
    },
    TEST_TOKEN: {
        EU: 'b5ccc144-cb60-11ea-ba6c-9e994002a52c',
        GB: '65e07b30-f36a-11ea-9df7-4e6a9bf87271',
        US: '96e79650-723e-11ed-93c1-1eb986dbebc2',
    },
    USER_CENTRICS_CONSENT_NAME: 'BloomReach',
};
export const LAUNCH_DARKLY = {
    CONSENT_ID: 'ubhL2_Fh9I0lSx',
    USER_CENTRICS_CONSENT_NAME: 'LaunchDarkly',
};
export const LOCAL_ENVS = [
    /^localhost/,
    /^core\.dev/,
    /raisin-dev/,
    /^bk-/,
    /bk\./,
    /staging-/,
    /app.dev-raisin.com/,
    /netlify/,
];
export const GB_LOCALES = ['en_GB', 'en-GB'];
export const US_LOCALES = ['en-us'];
export const DE_LOCALES = ['de', 'de_DE', 'de-DE', 'at', 'de_AT', 'de-AT'];
export const IDENTIFIED_USER_SESSION_NAME = 'user_is_identified';
export const COOKIE_FOR_SESSION_NAME = 'obs-session';
export const COOKIE_FOR_MOBILE_NAME = 'mobile';
export const AUTH_TOKEN_KEY = 'auth_token';
export const AUTH_TIME_DIFF_KEY = 'auth_time_diff';
export const LAUNCH_DARKLY_CONSENT_STATUS = 'launchDarklyConsentStatus';
//# sourceMappingURL=constants.js.map